import type { FaireProductEntity } from "../../entity_types/product";

export const p_b8g7g7btfc: FaireProductEntity = {
  token: "p_b8g7g7btfc",
  type: "product",
  name: "Yellow Garden Anniversary Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d062bb0eac94011702f572ec91e02ea7b33a748ecf3611c8e0250a57c944b034.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5a4a06e5e7eff0c2ccf1aa446accff34fd5ddfc2d02d6d59e9b977de6c7097d7.jpeg",
    "https://cdn.faire.com/fastly/46028691c7db88a5391ef7ca383d4264ec0458353a605834a81dd73c775175af.jpeg",
  ],
  priceDollars: 3,
  description:
    "What you give your attention to grows... here's to growing together.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:50.997Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
